import axios from 'axios';
import { baseUrl,baseUrl_SPB } from '../BaseUrl'


const DeleteBookedItem = async (bookedItem, token) => {
    try {
        // Call both endpoints
        const userPromise = axios.post(`${baseUrl_SPB}/api/v1/usertimeallocation/delete`, bookedItem, {
            headers: {
                'Authorization': 'Bearer ' + token
            },
        });
       
        // Wait for both to complete, return both results
        const [userResult] = await Promise.allSettled([userPromise]);
        if (userResult && userResult.status === 'fulfilled' && userResult.value && userResult.value.data) {
            return userResult.value.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error deleting booked item:', error);
        return null;
    }
}


export default DeleteBookedItem;;